import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Login from "./views/user/login";
import Error from "views/error";
import Unauthorized from "views/unauthorized";
import AppLayout from "layout/AppLayout";
import Blank from "views/app/Blank";
import UsersList from "views/app/users/usersList";
import AddUser from "views/app/users/add";
import { PrivateRoute } from "auth/privateRoute";
import CoursesList from "views/app/courses/coursesList";
import CoursePage from "views/app/courses/coursePage";
import ModulePage from "views/app/courses/modulePage";
import TaskPage from "views/app/courses/taskPage";
import CourseDetails from "views/app/courses/courseDetails";

function App() {
  return (
    <div className="App">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />

          <Route path="/error" element={<Error />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route
            path="/app"
            element={
              <PrivateRoute>
                <AppLayout />
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/app/courses"
            element={
              <PrivateRoute>
                <CoursesList />
              </PrivateRoute>
            }
          />
          <Route
            path="/app/courses/:id"
            element={
              <PrivateRoute>
                <CoursePage />
              </PrivateRoute>
            }
          />

          <Route
            path="/app/course/add"
            element={
              <PrivateRoute>
                <CourseDetails />
              </PrivateRoute>
            }
          />
          <Route
            path="/app/course/:id"
            element={
              <PrivateRoute>
                <CourseDetails />
              </PrivateRoute>
            }
          />
          <Route
            path="/app/module/:id"
            element={
              <PrivateRoute>
                <ModulePage />
              </PrivateRoute>
            }
          />
          <Route
            path="/app/task/inner/:id"
            element={
              <PrivateRoute>
                <TaskPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/app/task/:id"
            element={
              <PrivateRoute>
                <TaskPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/app/users"
            element={
              <PrivateRoute>
                <UsersList />
              </PrivateRoute>
            }
          />
          <Route
            path="/app/users/add"
            element={
              <PrivateRoute>
                <AddUser />
              </PrivateRoute>
            }
          />
          <Route
            path="/app/users/:id"
            element={
              <PrivateRoute>
                <AddUser />
              </PrivateRoute>
            }
          />
          <Route path="*" element={<Error />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
